import classnames from 'classnames';
import './SortIcon.css';

interface SortIconProps {
  /**
   * The current sort direction: 'asc', 'desc', or null for unsorted
   */
  sortDirection?: 'asc' | 'desc' | null;
  /**
   * Additional class name
   */
  className?: string;
  /**
   * Size of the icon in pixels (default: 20)
   */
  size?: number;
}

function SortIcon({ sortDirection = null, className, size = 20 }: SortIconProps) {
  const sortClasses = classnames('sort-icon', className, {
    'sort-icon--asc': sortDirection === 'asc',
    'sort-icon--desc': sortDirection === 'desc',
  });

  return (
    <svg
      aria-hidden='true'
      className={sortClasses}
      fill='currentColor'
      focusable='false'
      style={{ height: `${size}px`, width: `${size}px` }}
      viewBox='0 0 11.4281 16'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        className='sort-icon__up'
        clipRule='evenodd'
        d='M0.715047 6.85693H10.711C10.8526 6.85773 10.9912 6.81635 11.1093 6.73804C11.2273 6.65974 11.3193 6.54808 11.3736 6.41728C11.4279 6.28647 11.442 6.14246 11.4142 6.0036C11.3863 5.86474 11.3178 5.73731 11.2172 5.63758L6.2164 0.209356C6.15112 0.143051 6.07328 0.090394 5.98745 0.0544519C5.90161 0.0185098 5.80949 0 5.71643 0C5.62338 0 5.53126 0.0185098 5.44542 0.0544519C5.35959 0.090394 5.28175 0.143051 5.21647 0.209356L0.209937 5.63872C0.143458 5.70402 0.0906544 5.78192 0.0546093 5.86786C0.0185644 5.9538 0 6.04607 0 6.13926C0 6.23244 0.0185644 6.32471 0.0546093 6.41065C0.0906544 6.49659 0.143458 6.57449 0.209937 6.6398C0.274764 6.70866 0.35305 6.76347 0.43994 6.80082C0.526831 6.83818 0.62047 6.85727 0.715047 6.85693Z'
        fillRule='evenodd'
      />
      <path
        className='sort-icon__down'
        clipRule='evenodd'
        d='M10.711 9.14248H0.715047C0.621214 9.14081 0.528026 9.1583 0.441178 9.19386C0.35433 9.22943 0.275647 9.28232 0.209937 9.34933C0.143458 9.41464 0.0906544 9.49254 0.0546093 9.57848C0.0185644 9.66441 0 9.75668 0 9.84988C0 9.94306 0.0185644 10.0353 0.0546093 10.1213C0.0906544 10.2072 0.143458 10.2851 0.209937 10.3504L5.21532 15.7901C5.28063 15.8566 5.35854 15.9094 5.44448 15.9454C5.53041 15.9814 5.62267 16 5.71586 16C5.80906 16 5.90131 15.9814 5.98725 15.9454C6.0732 15.9094 6.15109 15.8566 6.2164 15.7901L11.2172 10.3618C11.3178 10.2621 11.3863 10.1347 11.4142 9.99581C11.442 9.85695 11.4279 9.71294 11.3736 9.58213C11.3193 9.45133 11.2273 9.33967 11.1093 9.26137C10.9912 9.18306 10.8526 9.14168 10.711 9.14248Z'
        fillRule='evenodd'
      />
    </svg>
  );
}

export default SortIcon;
